import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  skillsSection,
  openSource
} from "../../portfolio";
import ReactGA from "react-ga";
function Header() {
  const {isDark} = useContext(StyleContext);
  const viewExperience = workExperiences.display;
  const viewOpenSource = openSource.display;
  const viewSkills = skillsSection.display;

  const analyticsSkillsClick = value => () => {
    const ButtonName = value;
    // console.log(ButtonName);
    ReactGA.event({
      category: ButtonName,
      action: "Clicked on Button in the Top-Nav",
      label: "Anchor Tag Button"
    });
  };

  // const analyticsSkillsClick = value => {
  //   console.log(value);
  //   ReactGA.event({
  //     category: "Button",
  //     action: "Clicked on Skills Button in the Top-Nav"
  //   });
  // };

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a
          href="/"
          className="logo"
          onClick={analyticsSkillsClick("Logo-Button-Header")}
        >
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {viewSkills && (
            <li>
              <a
                href="#skills"
                onClick={analyticsSkillsClick("Skills-Button-Header")}
              >
                Skills
              </a>
            </li>
          )}
          {viewExperience && (
            <li>
              <a
                href="#experience"
                onClick={analyticsSkillsClick("Experience-Button-Header")}
              >
                Experience
              </a>
            </li>
          )}
          {viewOpenSource && (
            <li>
              <a
                href="#opensource"
                onClick={analyticsSkillsClick("Projects-Button-Header")}
              >
                Projects
              </a>
            </li>
          )}
          <li>
            <a
              href="#contact"
              onClick={analyticsSkillsClick("Contact-Button-Header")}
            >
              Contact Me
            </a>
          </li>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={analyticsSkillsClick("DarkTheme-Button-Header")}>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
